import { Component } from '@angular/core';

@Component({
    selector: 'lokos-need-help-card',
    templateUrl: './need-help-card.component.html',
    styleUrl: './need-help-card.component.scss',
    standalone: false,
})
export class NeedHelpCardComponent {
    onClick() {
        window.open('https://support.lokos.in', '_blank', 'noopener,noreferrer');
    }
}
